import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de698b5c6a30cb/components/forms/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/app/[locale]/contact/contact.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleMapLazy"] */ "/tmp/8de698b5c6a30cb/components/ui/GoogleMapLazy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de698b5c6a30cb/components/ui/Section.module.css");
